import BaseNodeResolver from '@/Modules/Quote/Components/QuoteForm/UiRules/BaseNodeResolver.js'
import UiRuleAction from '@/Modules/Quote/Components/QuoteForm/UiRules/Actions/UiRuleAction.js'
import _ from 'lodash'

export default class ShowByValueLt extends UiRuleAction {
  constructor(baseNode, options = {}) {
    super(baseNode, new BaseNodeResolver(baseNode))

    _.forEach(options, (value, field) => {
      this[_.camelCase(field)] = value
    })
  }

  /**
   *
   * @param {object} rule
   * @returns {object} baseNode
   */
  execute(rule) {
    const value = parseFloat(this.resolver.getValueByRuleOrSource(rule))

    const parameters = this.resolver.parseParameters(rule.parameters)
    const x = parseFloat(_.first(parameters))

    if (value > x || (this.orEqual && value >= x)) {
      this.resolver.setVisibility(rule.target, false)
    } else {
      this.resolver.setVisibility(rule.target, true)
    }

    return this.baseNode
  }
}
